<template>
    <div>
      <h2>Enable your customers to process returns</h2>
      <form @submit.prevent="submitForm">
        <div class="inputs-cover">
          <div>
            <input type="checkbox" id="customerReturns" value="Customer Returns" v-model="selectedReturnsOptions">
            <label for="customerReturns">Charge my Account for customer returns<span> (i)</span></label>
          </div>
          <div>
            <input type="checkbox" id="returnsProcessed" value="Returns Processed" v-model="selectedReturnsOptions">
            <label for="returnsProcessed">Charge customers for returns processed <span>(i)</span></label>
          </div>
        </div>
        <div class="returns-cover">
          <h2>Ship returns to:</h2>
          <div class="cover-box">
            <div class="box-cover flex">
              <div class="color-box" :style="{ backgroundColor: isYellow ? '#FFA600' : '#FFFFFF' }"
                @click="toggleBackgroundColor"></div>
              <p class="ml-2">Customer Service Center</p>
            </div>
            <div class="box-cover flex">
              <div class="color-box" :style="{ backgroundColor: isYellowOne ? '#FFA600' : '#FFFFFF' }"
                @click="toggleBackgroundColorOne"></div>
              <p class="ml-2">Original Purchase Location</p>
            </div>
            <div class="box-cover flex">
              <div class="color-box" :style="{ backgroundColor: isYellowTwo ? '#FFA600' : '#FFFFFF' }"
                @click="toggleBackgroundColorTwo"></div>
              <p class="ml-2">Nearest Outlet</p>
            </div>
          </div>
          <input class="px-6 py-2" type="text" placeholder="--Enter Address--" name="" id="">
        </div>
        <Actions />
      </form>
    </div>
  </template>
    
  <script>
  import Actions from "@/components/EnterpriseCustomer/Settings/actions.vue";
  
  export default {
     name: 'Returns',
    components: {
          Actions,
      },
    data() {
      return {
        isYellow: false,
        isYellowOne: false,
        isYellowTwo: false,
        time: 'default',
        selectedReturnsOptions: []
      };
    },
    methods: {
      submitForm() {
      },
      toggleBackgroundColor() {
        this.isYellow = !this.isYellow;
      },
      toggleBackgroundColorOne() {
        this.isYellowOne = !this.isYellowOne;
      },
      toggleBackgroundColorTwo() {
        this.isYellowTwo = !this.isYellowTwo;
      },
       back() {
        this.$router.go(-1)
      }
    }
  };
  </script>
  
  <style scoped>
  h2 {
    margin-left: 5%;
    margin-top: 5%;
    color: rgba(252, 194, 16, 1);
  }
  span {
    color: rgba(252, 194, 16, 1);
    font-size: 12px;
    font-weight: 400;
  }
  form {
    margin-top: 6%;
  }
  .inputs-cover {
    width: 85%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10%;
    padding-left: 5%;
  }
  .returns-cover>h2 {
    color: rgba(16, 35, 62, 1);
    font-size: 16px;
    font-weight: 600;
    margin-top: 0;
  }
  .returns-cover>input{
    border: 1px solid rgba(194, 199, 214, 1);
    border-radius: 8px;
    margin-left: 5%;
    margin-top: 3%;
  }
  .returns-cover>input::placeholder {
      color: rgba(102, 116, 153, 1);
      font-size: 14px;
      font-style: italic;
      font-weight: 400;
    }
  .color-box {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    border: 1px solid #C5C4D4;
    cursor: pointer;
  }
  .box-cover {
    align-items: center;
  }
  .box-cover>p{
    color: rgba(20, 23, 31, 1);
    font-size: 14px;
    font-weight: 400;
  }
  .cover-box{
    display: flex;
    /* border: 1px solid yellow; */
    margin-left: 5%;
    margin-top: 5%;
    justify-content: space-between;
    width: 90%;
  }
</style>